import { ReactQueryStaleTime } from '@openx/constants/react-query.ts';
import { QueryKeys } from '@openx/utils/api/queryKeys.ts';
import { useQuery } from '@tanstack/react-query';
import { GetAccountNetworkIdByUidDocument } from '../../../graphql/query/organizations/GetAccountNetworkIdByUid.generated.tsx';
import { getGraphQLRequestFromClient } from '../../../modules/graphql/types.ts';

// Resolves the exchange account network id of a single account; the query runs only when `accountUid` is provided
type UseAccountNetworkIdFetchResult = {
  accountId: string | undefined;
  error: Error | null;
  loading: boolean;
};

export const useAccountNetworkIdFetch = (accountUid: string | null | undefined): UseAccountNetworkIdFetchResult => {
  const { data, error, isLoading } = useQuery({
    enabled: !!accountUid,
    queryFn: ({ client }) =>
      getGraphQLRequestFromClient(client)(GetAccountNetworkIdByUidDocument, { uid: accountUid as string }),
    queryKey: [QueryKeys.ACCOUNT, 'networkIdByUid', accountUid],
    staleTime: ReactQueryStaleTime.MINUTES_15,
  });

  return {
    accountId: data?.account[0]?.exchange_account_network_id ?? undefined,
    error,
    loading: isLoading,
  };
};
